// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pagination-container[data-v-0d27aeac] {\n  text-align: left;\n  background: #fff;\n  /* padding: 32px 16px; */\n  box-sizing: border-box;\n  margin-top: 20px;\n  /* padding: 10px 0; */\n}\n.pagination-container.hidden[data-v-0d27aeac] {\n  display: block;\n}\n", ""]);
// Exports
module.exports = exports;
